/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesAnswerOptions } from './WebApiModelsEnumerationTypesAnswerOptions';
import {
    WebApiModelsEnumerationTypesAnswerOptionsFromJSON,
    WebApiModelsEnumerationTypesAnswerOptionsFromJSONTyped,
    WebApiModelsEnumerationTypesAnswerOptionsToJSON,
} from './WebApiModelsEnumerationTypesAnswerOptions';
import type { WebApiModelsEnumerationTypesEventType } from './WebApiModelsEnumerationTypesEventType';
import {
    WebApiModelsEnumerationTypesEventTypeFromJSON,
    WebApiModelsEnumerationTypesEventTypeFromJSONTyped,
    WebApiModelsEnumerationTypesEventTypeToJSON,
} from './WebApiModelsEnumerationTypesEventType';
import type { WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto } from './WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto';
import {
    WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoToJSON,
} from './WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto';

/**
 * An event in the list a logged in member sees on the public site.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceMemberEventDto {
    /**
     * The unique id of the event, used in the link to it.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    uniqueId?: string | null;
    /**
     * Name of the event.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    name?: string | null;
    /**
     * Description of the event.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    description?: string | null;
    /**
     * Where the event takes place.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    location?: string | null;
    /**
     * Last day to answer, when there is one.
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    deadline?: Date | null;
    /**
     * True when the member already has a reply for the event.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    hasReplied?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEventType}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    eventType?: WebApiModelsEnumerationTypesEventType;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesAnswerOptions}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    answerOptions?: WebApiModelsEnumerationTypesAnswerOptions;
    /**
     * The times of the event, the earliest first.
     * @type {Array<WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberEventDto
     */
    times?: Array<WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDto> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceMemberEventDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceMemberEventDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberEventDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceMemberEventDto {
    return WebApiServicesDataTransferObjectsReplyServiceMemberEventDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceMemberEventDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uniqueId': !exists(json, 'uniqueId') ? undefined : json['uniqueId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'deadline': !exists(json, 'deadline') ? undefined : (json['deadline'] === null ? null : new Date(json['deadline'])),
        'hasReplied': !exists(json, 'hasReplied') ? undefined : json['hasReplied'],
        'eventType': !exists(json, 'eventType') ? undefined : WebApiModelsEnumerationTypesEventTypeFromJSON(json['eventType']),
        'answerOptions': !exists(json, 'answerOptions') ? undefined : WebApiModelsEnumerationTypesAnswerOptionsFromJSON(json['answerOptions']),
        'times': !exists(json, 'times') ? undefined : (json['times'] === null ? null : (json['times'] as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberEventDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceMemberEventDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uniqueId': value.uniqueId,
        'name': value.name,
        'description': value.description,
        'location': value.location,
        'deadline': value.deadline === undefined ? undefined : (value.deadline === null ? null : value.deadline.toISOString()),
        'hasReplied': value.hasReplied,
        'eventType': WebApiModelsEnumerationTypesEventTypeToJSON(value.eventType),
        'answerOptions': WebApiModelsEnumerationTypesAnswerOptionsToJSON(value.answerOptions),
        'times': value.times === undefined ? undefined : (value.times === null ? null : (value.times as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceMemberEventTimeDtoToJSON)),
    };
}

